module.exports = __webpack_public_path__ + "assets/img/PanoramicKanban.1e9e96eb.png";